/**
 * @generated SignedSource<<5133cc8960833d7c3552025494c20dc0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useProductSceneQuery$variables = {
  productId: string;
};
export type useProductSceneQuery$data = {
  readonly model: {
    readonly id: string;
    readonly modelID: number;
    readonly scenes: ReadonlyArray<{
      readonly sceneID: any;
    }>;
  } | null;
};
export type useProductSceneQuery = {
  response: useProductSceneQuery$data;
  variables: useProductSceneQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "productId"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "model",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modelID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ModelScene",
        "kind": "LinkedField",
        "name": "scenes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sceneID",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useProductSceneQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useProductSceneQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "00077bf3b9019a892b233bc044b6410a",
    "id": null,
    "metadata": {},
    "name": "useProductSceneQuery",
    "operationKind": "query",
    "text": "query useProductSceneQuery(\n  $productId: ID!\n) {\n  model(id: $productId) {\n    id\n    modelID\n    scenes {\n      sceneID\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b74a6520b6d04ce7402ad6c71f9e0c77";

export default node;
